import React, { FC } from 'react'
import { Link } from 'gatsby-plugin-react-i18next'
import logoDark from 'src/images/svg/logo-full-dark.svg'
import logoLight from 'src/images/svg/logo-full-light.svg'
import logoRed from 'src/images/svg/logo-full-red.svg'

export const DesktopLogo: FC<{ className?: string }> = ({ className = '' }) => (
  <Link to="/" className={`block relative group shrink-0 ${className}`}>
    <img
      src={logoDark}
      alt="MAMF logo"
      className="w-40 lg:w-32 xl:w-40 dark:hidden transition-opacity duration-700 ease-in-out group-hover:opacity-0"
    />
    <img
      src={logoLight}
      alt="MAMF logo"
      className="w-40 lg:w-32 xl:w-40 hidden dark:block transition-opacity duration-700 ease-in-out group-hover:opacity-0"
    />
    <img
      src={logoRed}
      alt="MAMF logo"
      className="w-40 lg:w-32 xl:w-40 absolute inset-0 opacity-0 transition-opacity duration-700 ease-in-out group-hover:opacity-100 pointer-events-none"
    />
  </Link>
)

export default DesktopLogo
